import { tw } from "@careinfo/tailwind";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import AddInventoryPopup from "../AddIProductPopup";
import CreateUnit from "../InventoryInfo/CreateUnit";
import ProductGroupForm from "../InventoryInfo/ProductGroup";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import PopupModal from "../Reusable/Modal";
import CreateParty from "./CreateParty";
import PurchaseForm from "./PurchaseForm";
import { getKey } from "../../helpers/sessionKey";
import { yupResolver } from "@hookform/resolvers/yup";
import { TradingSalesSchema } from "../../validation/Sales";

const EditDraftPurchase = (props: any) => {
  const {
    handleEdit,
    handleRevert,
    isLoading,
    companyData,
    data,
    openPrintPopup,
    handlePrint,
    isRevertLoading,
    handleCancel,
    setOpenPrintPopup,
    isPrintLoading,
  } = props;
  const [openUnitFormPopup, setOpenUnitFormPopup] = useState(false);
  const [openCategoryFormPopup, setOpenCategoryFormPopup] = useState(false);
  const [isOpenModalPopup, setIsOpenModalPopup] = useState(false);
  const [openCancelBiLLPopup, setOpenCancelBillPopup] = useState(false);
  const [isOpenItemsPopup, setIsOpenItemsPopup] = useState(false);
  const navigate = useNavigate();
  const {
    control,
    register,
    setValue,
    setError,
    getValues,
    clearErrors,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm<any>({
    resolver: yupResolver(TradingSalesSchema),
    defaultValues: async () => {
      return {
        ...data,
        default_purchase_account: companyData?.default_purchase_account?.name,
        items: data?.items.map((item) => ({
          account: { ...item?.account, is_taxable: item?.is_taxable },
          quantity: item?.quantity,
          rate: Number(item?.rate),
          hs_code: item?.account?.hs_code,
          amount: item?.total,
          discount: item?.discount,
          unit: item?.account?.unit?.name,
        })),
      };
    },
  });
  const items = watch("items");
  const vat_tax = watch("tax_rate");

  useEffect(() => {
    if (!Array.isArray(items)) return;

    let taxableTotal = 0;
    let nonTaxableTotal = 0;
    let itemsValue = 0;
    let totalDiscount = 0;

    items.forEach((item, index) => {
      const amount = Number(item?.amount) || 0;
      const discount = Number(item?.discount) || 0;
      const isTaxable = Boolean(item?.is_taxable);

      itemsValue += amount;
      const amountAfterDiscount = Math.max(amount - discount, 0);
      totalDiscount += discount;

      if (isTaxable) {
        taxableTotal += amountAfterDiscount;
      } else {
        nonTaxableTotal += amountAfterDiscount;
      }
    });

    const netAmount = taxableTotal + nonTaxableTotal;
    const vatTax = taxableTotal * (Number(vat_tax) / 100);
    const totalAmount = netAmount + vatTax;

    setValue("items_value", itemsValue.toFixed(2));
    setValue("vat_tax_amount", vatTax.toFixed(2));
    setValue("total_amount", totalAmount.toFixed(2));
    setValue("taxable_amount", taxableTotal.toFixed(2));
    setValue("non_taxable_amount", nonTaxableTotal.toFixed(2));
    setValue("total_discount", totalDiscount.toFixed(2));
  }, [JSON.stringify(items), setValue, vat_tax]);

  const handleClosePrint = () => {
    setOpenPrintPopup(false);
    navigate("/accounting/purchase");
  };

  const isSuperUser = getKey("is_superuser");
  const adminOnly = data?.is_draft;
  return (
    <>
      <Card>
        <form
          onSubmit={handleSubmit((data) => handleEdit(data, false, setError))}
        >
          <PurchaseForm
            control={control}
            register={register}
            errors={errors}
            getValues={getValues}
            companyData={companyData}
            setValue={setValue}
            isDraft={adminOnly}
            setIsOpenItemsPopup={setIsOpenItemsPopup}
            setOpenUserFormPopup={setIsOpenModalPopup}
            clearErrors={clearErrors}
            watch={watch}
          />
          <div className={tw`w-full flex gap-x-4 justify-end px-4`}>
            {/* <div className={tw`w-24 `}>
              <Button
                type="button"
                // disabled={!adminOnly}
                label="Cancel"
                isLoading={isLoading}
                onClick={() => setOpenCancelBillPopup(true)}
              />
            </div> */}
            {data?.is_draft ? (
              <div className={tw`w-24 `}>
                <Button
                  type="button"
                  disabled={!adminOnly}
                  label="Save to Draft"
                  isLoading={isLoading}
                  onClick={handleSubmit((data) =>
                    handleEdit(data, true, setError)
                  )}
                />
              </div>
            ) : (
              <div className={tw`w-24 `}>
                <Button
                  type="button"
                  // disabled={!adminOnly}
                  label="Revert"
                  isLoading={isRevertLoading}
                  onClick={() => handleRevert(setError)}
                />
              </div>
            )}
            <div className={tw`w-24`}>
              <Button
                label="Submit"
                disabled={!data?.is_draft}
                isLoading={isLoading}
              />
            </div>
          </div>
        </form>
      </Card>
      <PopupModal
        isOpen={isOpenModalPopup}
        setIsOpen={setIsOpenModalPopup}
        title="Create Party"
      >
        <CreateParty
          setOpenUserFormPopup={setIsOpenModalPopup}
          setValue={setValue}
        />
      </PopupModal>
      <PopupModal
        isOpen={openCancelBiLLPopup}
        setIsOpen={setOpenCancelBillPopup}
        title="Cancel Bill"
      >
        <div className={tw`p-4 mt-10`}>
          <p className={tw`text-gray-600 mb-6`}>
            Are you sure you want to cancel this bill? This action cannot be
            undone.
          </p>

          <div className={tw`flex justify-center gap-3`}>
            <button
              onClick={() => setOpenCancelBillPopup(false)}
              className={tw`px-6 py-2 rounded-md focus:outline-none bg-gray-200 text-gray-800 hover:bg-gray-300 transition`}
            >
              No
            </button>

            <button
              onClick={() => {
                handleCancel();
                setOpenCancelBillPopup(false);
              }}
              className={tw`px-6 py-2 rounded-md  focus:outline-none bg-red-600 text-white hover:bg-red-700 transition`}
            >
              Yes
            </button>
          </div>
        </div>
      </PopupModal>
      <PopupModal
        isOpen={openPrintPopup}
        setIsOpen={handleClosePrint}
        title={"Print"}
      >
        <form action="#" className={tw`w-[600px]`}>
          <Button
            label={"Print "}
            type="button"
            isLoading={isPrintLoading}
            disabled={isPrintLoading}
            onClick={handlePrint}
            autoFocus
          />
          <Button
            type="button"
            label={"Close"}
            onClick={() => handleClosePrint()}
          />
        </form>
      </PopupModal>
      <PopupModal
        isOpen={isOpenItemsPopup}
        setIsOpen={setIsOpenItemsPopup}
        title="Create Items"
      >
        <AddInventoryPopup
          setOpenInventoryFormPop={setIsOpenItemsPopup}
          setOpenCategoryFormPopup={setOpenCategoryFormPopup}
          setOpenUnitFormPopup={setOpenUnitFormPopup}
          setItems={setValue}
        />
      </PopupModal>

      <PopupModal
        title="Create unit"
        isOpen={openUnitFormPopup}
        setIsOpen={setOpenUnitFormPopup}
      >
        <CreateUnit setOpenUnitFormPopup={setOpenUnitFormPopup} />
      </PopupModal>
      <PopupModal
        title="Create Category"
        isOpen={openCategoryFormPopup}
        setIsOpen={setOpenCategoryFormPopup}
      >
        <div className={tw`min-w-[400px]`}>
          <ProductGroupForm
            setOpenCategoryFormPopup={setOpenCategoryFormPopup}
          />
        </div>
      </PopupModal>
    </>
  );
};

export default EditDraftPurchase;
